import React from 'react'
import { Box, Spinner } from '@intellihr/blueberry'
import { useScope } from 'src/services/i18n/LocalizationProvider'

/* Try to use Skeletons instead of this component for initial page loads */
const PageSpinner = () => {
  const tCommonComponents = useScope('common:components')

  return (
    <Box
      position="fixed"
      style={{
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: '999',
      }}
    >
      <Spinner
        testId="page-spinner"
        label={tCommonComponents('spinners.loading')}
      />
    </Box>
  )
}

export { PageSpinner }
